<template>
  <Admin>
    <v-main v-if="!isProductListLoading" class="wrapper">
        <v-container v-if="!selectedCompanyProductList?.isFixedAssetCount" fluid>
        You are not allowed for this feature, Please contact Sales
        <a href="tel:026637895" target="_blank"
        ><b><u>026637895</u></b></a
        >
      </v-container>
      <v-container v-else fluid>
        <div class="mb-1 tw-text-xl tw-font-bold tw-mb-3">
            <h1>Fixed Asset List</h1>
        </div>
        <v-divider/>

        <!-- Filter Section -->
        <v-row class="tw-my-4 px-4">
          <v-col cols="12" sm="6" md="2">
            <v-text-field
              v-model="assetCodeFilter"
              label="Filter by Asset Code"
              prepend-icon="mdi-magnify"
              clearable
              dense
              outlined
              hide-details
              :disabled="isLoading"
              @input="onFilterChange"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-select
              v-model="countStatusFilter"
              :items="countStatusOptions"
              label="Filter by Count Status"
              prepend-icon="mdi-filter"
              clearable
              dense
              outlined
              hide-details
              :disabled="isLoading"
              @change="onFilterChange"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-select
              v-model="departmentFilter"
              :items="departmentOptions"
              label="Filter by Department"
              prepend-icon="mdi-office-building"
              clearable
              dense
              outlined
              hide-details
              :disabled="isLoading"
              @change="onFilterChange"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-select
              v-model="locationFilter"
              :items="locationOptions"
              label="Filter by Location"
              prepend-icon="mdi-map-marker"
              clearable
              dense
              outlined
              hide-details
              :disabled="isLoading"
              @change="onFilterChange"
            ></v-select>
          </v-col>
          <v-col cols="12" md="1" class="d-flex align-center">
            <v-btn
              color="primary"
              @click="clearFilters"
              outlined
              small
              :disabled="isLoading"
              :loading="isLoading"
            >
              <v-icon left small>mdi-filter-off</v-icon>
              Clear Filters
            </v-btn>
          </v-col>
        </v-row>
    

        <v-row justify="center">
          <v-col style="position: relative; min-height: 400px;">
            <!-- Loading Overlay -->
            <v-overlay :value="isLoading" absolute color="white" opacity="0.8">
              <v-progress-circular
                indeterminate
                size="64"
                color="primary"
              ></v-progress-circular>
            </v-overlay>

            <asset-table
              :data="assetList"
              :current-page="currentPage"
              :items-per-page="itemsPerPage"
              @syncNs="syncDataFromNetsuite"
            ></asset-table>
          </v-col>
        </v-row>
        <v-row justify="start" class="tw-my-4">
          <v-col>
            <select class="items-per-page-selector" v-model="itemsPerPage" :disabled="isLoading">
              <option
                v-for="option in itemsPerPageOptions"
                :key="option"
                :value="option"
                :selected="option === itemsPerPage"
              >
                {{ option }}
              </option>
            </select>
          </v-col>
          <v-col>
            <v-pagination
              v-model="currentPage"
              :length="numPages"
              :total-visible="10"
              :disabled="isLoading"
            ></v-pagination>
          </v-col>
          <v-col class="tw-flex tw-items-end tw-justify-end">
            <p class="total-item">จำนวนรายการทั้งหมด: {{ totalItems }}</p>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
     <v-snackbar v-model="sysnSuccess" color="primary" top>
      ซิงค์ข้อมูลสำเร็จ
    </v-snackbar>
  </Admin>
</template>
<script >
import Admin from '@/components/admin/admin-main-template.vue'
import fc from "@/firebaseConfig"; 
import firebase from "firebase/app";
import "firebase/auth";
import {mapState, mapActions} from "vuex";
import AssetTable from '@/components/admin/fixedAssets/assetTable.vue';
const axios = require('axios');
const OAuth01 = require('oauth-1.0a');
const crypto = require('crypto');

export default {
    name: "fixedAssetCount",
    components: {
        Admin,
        AssetTable
    },
    data(){
        return {
            loading: false,
            sysnSuccess: false,
            itemsPerPageOptions: [10, 20, 30, 40, 50],
            assetCodeFilter: '',
            countStatusFilter: null,
            departmentFilter: null,
            locationFilter: null,
            countStatusOptions: [
              { text: 'All', value: null },
              { text: 'Counted', value: 'Counted' },
              { text: 'Uncounted', value: 'Uncounted' },
              { text: 'New', value: 'New' },

            ],
            filterDebounce: null,
        }
    },
    computed: {
        ...mapState({
           selectedCompanyProductList: (state) =>
          state.companies.selectedCompanyProductList,
          isProductListLoading: (state) => state.companies.isProductListLoading,
          assetList: (state) => state.fixedAssets.assetList,
          pagination: (state) => state.fixedAssets.assetListPagination,
          isLoading: (state) => state.fixedAssets.isLoading,
          departments: (state) => state.fixedAssets.departments,
          locations: (state) => state.fixedAssets.locations
        }),
        departmentOptions() {
          if (!this.departments || this.departments.length === 0) {
            return [{ text: 'No departments available', value: null }];
          }
          return [
            { text: 'All', value: null },
            ...this.departments.map(dept => ({
              text: dept.name || dept,
              value: dept.name || dept
            }))
          ];
        },
        locationOptions() {
          if (!this.locations || this.locations.length === 0) {
            return [{ text: 'No locations available', value: null }];
          }
          return [
            { text: 'All', value: null },
            ...this.locations.map(loc => ({
              text: loc.name || loc,
              value: loc.name || loc
            }))
          ];
        },
        itemsPerPage: {
          get() {
            return this.pagination?.itemsPerPage || 10;
          },
          set(value) {
            const companyId = this.$route.params.companyId || localStorage.getItem('companyId');
            this.$store.dispatch('fixedAssets/changeAssetListItemsPerPage', {
              companyId,
              itemsPerPage: parseInt(value)
            });
          }
        },
        currentPage: {
          get() {
            return this.pagination?.currentPage || 1;
          },
          set(value) {
            const companyId = this.$route.params.companyId || localStorage.getItem('companyId');
            this.$store.dispatch('fixedAssets/goToAssetListPage', {
              companyId,
              page: value
            });
          }
        },
        numPages() {
          return this.pagination?.totalPages || 1;
        },
        totalItems() {
          return this.pagination?.totalItems || 0;
        },
    },
        methods: {
        ...mapActions({
            fetchAssetList: "fixedAssets/fetchAssetList",
            fetchDepartments: "fixedAssets/fetchDepartments",
            fetchLocations: "fixedAssets/fetchLocations",
            fetchAssetClasses: "fixedAssets/fetchAssetClasses",
            addNewAsset: "fixedAssets/addNewAsset",
            updateAsset: "fixedAssets/updateAsset",
            deleteAsset: "fixedAssets/deleteAsset",
            clearAllListeners: "fixedAssets/clearAllListeners"
        }), 
            async syncDataFromNetsuite() {
            // Set loading state
            this.loading = true;
            
            console.log('Syncing data from Netsuite...');
            this.$store.dispatch("setGlobalLoading", true);
            
            try {
                let token = await firebase.auth().currentUser.getIdToken(false);
                //  console.log('Firebase token:', token);
                
                const companyId = this.$route.params.companyId || localStorage.getItem("companyId");
                // console.log('Company ID being sent:', companyId);
                
                const response = await axios.get(
                    `${fc.cloudFunctionUrl}/apiFixedAssetNetsuite`,
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'companyID': companyId,
                            'Content-Type': 'application/json'
                        }
                    }
                );
                if (response.status !== 200) {
                    throw new Error(`Error syncing data: ${response.statusText}`);
                }else {
                    this.sysnSuccess = true;
                }
                // console.log('Data synced successfully:', response.data);
                this.$store.dispatch("setGlobalLoading", false);
                this.loading = false;
                
            } catch (error) {
                console.error('Error syncing data:', error);
                this.$store.dispatch("setGlobalLoading", false);
                this.loading = false;
            }
        },
        
        editItem(item) {
            // Implement edit functionality
            console.log('Editing item:', item);
            
            // Example - You could show a dialog and then update
            const confirmed = confirm(`Do you want to edit ${item.name}?`);
            if (confirmed) {
                const companyId = this.$route.params.companyID || localStorage.getItem("companyId");
                // Sample edit - in real app this would come from a form
                const updatedData = {
                    assetName: item.name + ' (Updated)',
                    updatedAt: new Date()
                };
                
                this.updateAsset({
                    companyId,
                    assetId: item.id,
                    assetData: updatedData
                });
            }
        },
        
        deleteItem(item) {
            // Implement delete functionality
            if (confirm(`Are you sure you want to delete ${item.name}?`)) {
                const companyId = this.$route.params.companyID || localStorage.getItem("companyId");
                this.deleteAsset({
                    companyId,
                    assetId: item.id
                }).then(result => {
                    if (result.success) {
                        console.log('Asset deleted successfully');
                    } else {
                        console.error('Failed to delete asset:', result.error);
                    }
                });
            }
        },
        onFilterChange() {
            // Debounce the filter to avoid too many requests
            clearTimeout(this.filterDebounce);
            this.filterDebounce = setTimeout(() => {
                this.applyFilters();
            }, 500);
        },
        applyFilters() {
            const companyId = this.$route.params.companyId || localStorage.getItem('companyId');
            if (companyId) {
                this.$store.dispatch('fixedAssets/setAssetListFilters', {
                    assetCode: this.assetCodeFilter,
                    countStatus: this.countStatusFilter,
                    department: this.departmentFilter,
                    location: this.locationFilter
                });
                this.$store.dispatch('fixedAssets/fetchAssetList', {
                    companyId,
                    page: 1, // Reset to first page when filtering
                    itemsPerPage: this.itemsPerPage
                });
            }
        },
        clearFilters() {
            this.assetCodeFilter = '';
            this.countStatusFilter = null;
            this.departmentFilter = null;
            this.locationFilter = null;
            this.applyFilters();
        },
        handleStorageChange(event) {
            // Handle localStorage changes from other tabs/windows
            if (event.key === 'pageLimit' && event.newValue !== event.oldValue) {
                const companyId = this.$route.params.companyId || localStorage.getItem('companyId');
                if (companyId) {
                    this.$store.dispatch('fixedAssets/syncItemsPerPageFromLocalStorage', {
                        companyId
                    });
                }
            }
        },
    },
    mounted() {
    // Get the company ID (this should match how your app gets the current company)
    const companyId = this.$route.params.companyId;
    const pageLimit = localStorage.getItem("pageLimit");
    const initialItemsPerPage = pageLimit === "auto" ? 10 : parseInt(pageLimit) || 10;
    console.log('Company ID:', companyId);

    // Clear filters on component mount to ensure fresh start
    this.$store.commit('fixedAssets/clearAssetListFilters');
    this.assetCodeFilter = '';
    this.countStatusFilter = null;
    this.departmentFilter = null;
    this.locationFilter = null;

    if (companyId) {
        console.log('Fetching data for company:', companyId);
        
        // Sync itemsPerPage from localStorage first
        this.$store.dispatch('fixedAssets/syncItemsPerPageFromLocalStorage', {
            companyId
        });
        
        // Fetch data from Firestore
        this.fetchAssetList({ companyId, itemsPerPage: initialItemsPerPage });
        this.fetchDepartments({ companyId });
        this.fetchLocations({ companyId });
        // this.fetchAssetClasses({ companyId });
    }

    // Listen for localStorage changes (for when pageLimit is changed in another tab/window)
    window.addEventListener('storage', this.handleStorageChange);
    },
    beforeDestroy() {
        // Clean up listeners when component unmounts
        this.clearAllListeners();

        // Remove localStorage event listener
        window.removeEventListener('storage', this.handleStorageChange);

        // Clear filters when leaving the page
        const companyId = this.$route.params.companyId || localStorage.getItem('companyId');
        if (companyId) {
            this.$store.commit('fixedAssets/clearAssetListFilters');
        }
    },
};
</script>

<style scoped>
.items-per-page-selector {
  padding: 0.3rem .5rem;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.items-per-page-selector:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: #f5f5f5;
}

.total-item {
  margin-bottom: 0;
  font-size: 0.9rem;
}
</style>